<template>
  <v-layout>
    <div v-if="!createMode" class="d-flex justify-end flex-column full-width">
      <v-row v-if="node.meta.question">
        {{ node.meta.question }}
      </v-row>
      <v-row>
        <div class="mr-auto" v-if="!editMode">
          <div class="slider-wrapper">
            <vue-slider
              v-if="node.value.length"
              v-model="node.value[node.value.length - 1].val[0]"
              :min="computedMin"
              :max="computedMax"
              :interval="computedStep"
              :marks="marks1"
              tooltip="hover"
              disabled
            ></vue-slider>
            <div
              v-else
              class="font-weight-light blue-grey--text lighten-3 no-data"
            >
              -----
            </div>
          </div>
        </div>
      </v-row>

      <v-row v-if="editMode" class="edit-wrapper mr-auto">
        <div class="edit-wrapper mx-3">
          <vue-slider
            v-if="node.value.length > editIndex && editIndex > -1"
            v-model="node.value[editIndex].val[0]"
            :min="computedMin"
            :max="computedMax"
            :interval="computedStep"
            :marks="marks1"
            tooltip="always"
            class="slide-wrapper edit"
            @change="changeValue($event, node)"
          ></vue-slider>
          <vue-slider
            v-else
            disabled
            v-model="computedMin"
            :min="computedMin"
            :max="computedMax"
            :interval="computedStep"
            :marks="marks1"
            tooltip="always"
            class="slide-wrapper edit"
          ></vue-slider>
          <div class="text-caption mt-1" v-if="node.meta.uom">
            Unit Of Measure is {{ node.meta.uom }}
          </div>
        </div>
        <div v-if="valueIsEmpty" class="text-caption grey--text text--darken-2">
          This field is disabled until you select a date/time below
        </div>
      </v-row>
    </div>
    <v-form ref="form" v-if="createMode" class="full-width">
      <div class="d-flex justify-space-between full-width">
        <v-text-field
          class="mr-4"
          type="number"
          label="Minimum"
          v-model.number="node.meta.min"
          @input="validate()"
          :rules="[minAndMax]"
        ></v-text-field>
        <v-text-field
          class="mr-4"
          type="number"
          label="Maximum"
          v-model.number="node.meta.max"
          @input="validate()"
          :rules="[minAndMax]"
        ></v-text-field>
        <v-text-field
          type="number"
          label="Step"
          v-model.number="node.meta.step"
          :rules="[
            () => !!node.meta.step || 'A step is required',
            () => node.meta.step > 0 || 'Step must be greater than 0'
          ]"
          @input="validate()"
        ></v-text-field>
      </div>
      <div><AddUnits v-model="node.meta.uom" /></div>
      <v-row>
        <v-col>
          <div class="d-flex justify-space-between full-width">
            <v-text-field
              label="Question (optional)"
              v-model="node.meta.question"
              class="mr-4"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="d-flex justify-space-between full-width">
            <v-text-field
              label="Tooltip (optional)"
              v-model="node.meta.tooltip"
              class="mr-4"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import AddUnits from "../record-viewer/AddUnits";
import isFinite from "lodash/isFinite";

export default {
  name: "NumericScale",
  props: {
    node: Object,
    editMode: Boolean,
    editIndex: Number,
    createMode: { type: Boolean, default: false, required: false },
    selectedRecord: Object,
    isRoot: Boolean
  },
  mounted() {
    if (this.createMode) {
      this.validate();
    }
  },
  data() {
    return {
      marks1: val =>
        val % 1 === 0
          ? {
              label: `${val}`,
              labelStyle: {
                position: "relative",
                display: "flex",
                "justify-content": "center",
                "text-align": "center",
                width: "1px",
                background: "#000",
                height: "10px",
                "line-height": "40px",
                margin: "0 0 20px 0"
              }
            }
          : false
    };
  },
  computed: {
    ...mapGetters("allUoms", { units: "list" }, { root: true }),
    ...mapGetters({
      loginDetails: "getUser",
      getName: "getLoggedInName"
    }),
    computedMin() {
      return isFinite(this.node.meta.min)
        ? this.node.meta.min
        : parseFloat(this.node.meta.min, 10);
    },
    computedMax() {
      return isFinite(this.node.meta.max)
        ? this.node.meta.max
        : parseFloat(this.node.meta.max, 10);
    },
    computedStep() {
      return isFinite(this.node.meta.step)
        ? this.node.meta.step
        : parseFloat(this.node.meta.step, 10);
    },
    valueIsEmpty: function() {
      return this.node.value.length === 0;
    }
  },
  methods: {
    changeValue(e, node) {
      if (!e) {
        return;
      }
      node.value[this.editIndex].val[0] = e;
      node.value[this.editIndex].authorName = this.getName;
      node.value[this.editIndex].authorId = this.loginDetails.id;

      this.$emit("updateconditionalnodes");
      this.$root.$emit("edit:update");
    },
    validate() {
      const okay = this.$refs.form.validate();
      this.$emit("validation", okay);
    },
    minAndMax() {
      if (isFinite(this.node.meta.min) && isFinite(this.node.meta.max)) {
        return (
          this.node.meta.min < this.node.meta.max ||
          "The minimum must be less than the maximum"
        );
      }
      return "A minimum and a maximum are required";
    }
  },
  components: { AddUnits }
};
</script>
<style lang="scss">
.slider-wrapper {
  min-height: 50px;
  width: 600px;
}

.edit-wrapper {
  margin-top: 20px;
  min-height: 45px;
  width: 100%;
}

.no-data {
  border-bottom: 1px solid #000;
}
</style>
